import { z } from 'zod';
import { spawn } from '../../utils/translations';
import { CONNECT_TRANSLATION_KEY, FIELDS } from './consts';
import { normalizeGerritApiPrefix, normalizeGerritBaseUrl } from './utils';

export const getConnectFormSchema = () => {
  const spawnErrors = spawn(`${CONNECT_TRANSLATION_KEY}.errors`);

  return z.object({
    [FIELDS.BASE_URL]: z
      .string()
      .min(1, spawnErrors('base-url-required'))
      .refine(
        (value) => normalizeGerritBaseUrl(value) !== undefined,
        spawnErrors('base-url-invalid'),
      ),
    [FIELDS.USERNAME]: z
      .string()
      .trim()
      .min(1, spawnErrors('username-required')),
    [FIELDS.TOKEN]: z.string().min(1, spawnErrors('token-required')),
    // Optional: blank means "use the backend default", so only a non-blank value
    // that can't compose a working API URL is an error.
    [FIELDS.API_PREFIX]: z
      .string()
      .refine(
        (value) =>
          !value.trim() || normalizeGerritApiPrefix(value) !== undefined,
        spawnErrors('api-prefix-invalid'),
      ),
  });
};

export type ConnectFormData = z.infer<ReturnType<typeof getConnectFormSchema>>;
